export const MinorSettingsManagementRoutes = {
    "/school-templates-setup?brand_id&setup": {
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["minor-settings-management"]
        },
        "params": {},
        "component": "minorSchoolTemplatesSetupContainer",
        "showGlobalSearch": true,
        "loginRequired": true,
        "type": "frontend",
        "name": "appLayout.harriSH.school-templates-setup",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./minor-settings-management.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/work-restrictions/work-restrictions.module.js");
                }
            },

        ],
        "onEnter": ['$state', '$stateParams',
            function ($state, $stateParams) {
                if (!$stateParams.brand_id) {
                    $state.go('appLayout.harriSH.access-portal.settings.main', {
                        'activeTab': 'SCHOOL_CALENDARS',
                        'hmapPath': $stateParams['hmapPath']
                    }, {reload: true});
                }
            }]
    },
};
